export default {
  title: "Writers Union registry",
  subtitle: "Public profiles of Union members.",
  empty: "No public profiles yet.",
  searchPlaceholder: "Search by name or pseudonym",
  searchEmpty: "No writers match your search.",
  portfolio: "Portfolio",
  portfolioEmpty: "No verified works in the portfolio.",
  notFound: "Writer not found.",
  back: "Back to registry",
  openCatalog: "Open NBR catalogue card",
}
